import { forwardRef, useState } from 'react'
import { cn } from '../utils/cn.ts'

export interface AvatarProps {
  name: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  blurred?: boolean
  src?: string
  backgroundColor?: string
  borderColor?: string
  borderWidth?: number
  className?: string
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/)
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase()
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
}

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>(
  ({ name, size = 'md', blurred = false, src, backgroundColor, borderColor, borderWidth, className }, ref) => {
    const [imgError, setImgError] = useState(false)

    const showImage = src && !imgError

    const style: React.CSSProperties = {}
    if (backgroundColor) style.backgroundColor = backgroundColor
    if (borderColor) style.borderColor = borderColor
    if (borderWidth != null) style.borderWidth = borderWidth
    if (borderColor || borderWidth != null) style.borderStyle = 'solid'

    return (
      <div
        ref={ref}
        className={cn(
          'avatar',
          `avatar-${size}`,
          blurred ? 'avatar-blurred' : (!src || imgError ? 'avatar-standard' : ''),
          className,
        )}
        style={Object.keys(style).length > 0 ? style : undefined}
      >
        {showImage ? (
          <img
            src={src}
            alt={name}
            className="avatar-img"
            onError={() => setImgError(true)}
          />
        ) : (
          <span>{getInitials(name)}</span>
        )}
      </div>
    )
  },
)

Avatar.displayName = 'Avatar'
